export var logDevelopmentMessage = function (message, isError) {
    if (isError === void 0) { isError = false; }
    try {
        if (process.env.NODE_ENV === 'development') {
            if (isError) {
                // eslint-disable-next-line no-console
                console.error("@johnlewispartnership/wtr-ingredients\n".concat(message));
            }
            else {
                // eslint-disable-next-line no-console
                console.warn("@johnlewispartnership/wtr-ingredients\n".concat(message));
            }
        }
        // eslint-disable-next-line no-empty
    }
    catch (e) { }
};
//# sourceMappingURL=logDevelopmentMessage.js.map